/**
 * goi_common 으로 옮겼다. 기존 import 경로 유지를 위한 re-export.
 *
 * platform 의 무빈소 견적 결과 화면(#344)도 같은 후기를 쓰게 되면서, 앱별 복사본을 두면
 * 후기를 교체할 때 한쪽만 바뀐다. `excludeFacilities` 와 같은 이유로 목록은 한 곳에 둔다.
 */
export { GOI_TRUST, MUBINSO_REVIEWS } from "goi_common";
export type { MubinsoReview } from "goi_common";
